import { chipDayNum, chipDow, chipMon, chipTime } from './upcomingWorkshopsFormat';

/** The green date chip + clock. Reads the VENUE-LOCAL wall clock
 *  (`localStartDatetime`), never the absolute `startsAt` — the instant's digits
 *  are UTC, so rendering them re-anchors the workshop to whatever timezone the
 *  viewer's browser happens to be in (BON-386). Null local column → "—". */
export function WorkshopDateCell({ localStart }: { localStart: string | null }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <div
        className="nb-tabular"
        style={{
          // Fixed moss-600 regardless of theme — `--nb-primary` resolves to a
          // lighter green (#38c97e) in dark mode, but the date card must stay
          // #0e874b. Moss is a Tailwind palette with no matching CSS var, so the
          // literal hex is the correct source here.
          background: '#0e874b',
          color: '#fff',
          borderRadius: 8,
          minWidth: 42,
          padding: '4px 6px',
          textAlign: 'center',
          lineHeight: 1.15,
        }}
      >
        <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: '0.5px' }}>
          {chipDow(localStart)}
        </div>
        <div style={{ fontSize: 18, fontWeight: 800 }}>{chipDayNum(localStart)}</div>
        <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: '0.5px' }}>
          {chipMon(localStart)}
        </div>
      </div>
      <span style={{ fontSize: 12, color: 'var(--nb-subtle)' }}>{chipTime(localStart)}</span>
    </div>
  );
}
